import { createContext } from "react";
const PhotosContext = createContext({})
export default PhotosContext